import script from "./PasswordChangeRequiredModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordChangeRequiredModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__